import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../../redux/actions/index';
import * as enums from '../../../utils/enums';
import toastr from 'toastr';
import moment from 'moment-timezone';
import _reject from 'lodash/reject';
import _isEmpty from 'lodash/isEmpty';
import InventoryUtils from '../../../utils/inventory-utils';
import AllocationComponent from './allocation';

class AllocationComponentContainer extends Component {
    constructor(props) {
        super(props);
        this.onConfigurationOptionChange = this.onConfigurationOptionChange.bind(this);
        this.onAllocationStatusChange = this.onAllocationStatusChange.bind(this);
        this.onRoomTypeMaxAllotmentChange = this.onRoomTypeMaxAllotmentChange.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
    }

    onAllocationStatusChange(allocationStatus) {
        const { allocation } = this.props.model;
        let newStatus = allocationStatus.find((x) => x.selected).id;
        let status = newStatus === allocation.status || allocation.count === 'C' ? enums.FIXED : enums.CLOSED;
        let allocData = {
            ...allocation,
            status: status,
            count: status === enums.CLOSED ? 'C' : 0,
            releaseDays: status === enums.CLOSED ? 'C' : 0
        };

        let inventoryData = { ...this.props.model, allocation: allocData };

        if (allocationStatus[0].selected) {
            inventoryData.allocationRooms = inventoryData.allocationRooms.map((room) => {
                room.availableAllotment = 0;
                return room;
            });
        }

        this.props.actions.setModelObject(inventoryData);
    }

    onCheckboxChange(property, e) {
        const value = e.target.checked;

        let inventoryObject = {
            ...this.props.model,
            allocationActive: value,
            freesaleActive: true
        };

        this.props.actions.setModelObject(inventoryObject);
    }

    checkClosedAllocationFreesaleCount(iterationDate) {
        let allotmentCount;

        if (this.props.isNotTravcoUser) {
            let existingData = this.state.inventoryData.allocationByDay.find((e) =>
                moment.tz(e.dateOfAllocation, 'Europe/London').isSame(iterationDate, 'days')
            );
            if (existingData) allotmentCount = existingData.roomInventory.bookedDetails.currentAllocationTotal;
        } else {
            allotmentCount =
                this.state.allocation.count === 'C' ? enums.CLOSED_ALLOCATION_FREESALE : this.state.allocation.count;
        }

        let freeSaleCount =
            this.state.freesale.count === 'C'
                ? enums.CLOSED_ALLOCATION_FREESALE
                : this.state.freesale.count == '∞' ? enums.OPEN_INFINITY : this.state.freesale.count;

        return { allotmentCount, freeSaleCount };
    }

    onConfigurationOptionChange(property, value) {
        let count = this.props.model.allocationRooms.reduce((prev, current) => prev + Number(current.allotment), 0);
        let changedAllocation = { ...this.props.model.allocation, [property]: value };

        // Checks if allocation is less that the total number of rooms (avoid if property = 'releaseDays')
        if (property === 'count' && count <= value) {
            toastr.warning('Total Allocation must be less than total quantity of rooms.');
            changedAllocation.count = count < 0 ? 0 : count;
        }

        const changeObj = { ...this.props.model, allocation: changedAllocation };
        this.props.actions.setModelObject(changeObj);
    }

    onRoomTypeMaxAllotmentChange(isEdit, room, value) {
        const { allocationRooms, inventory } = this.props.model;
        let newAllotment = Object.assign({}, room, { allotment: value, availableAllotment: value });
        let roomTypes = [];

        if (isEdit) {
            roomTypes =
                allocationRooms.length === 0
                    ? InventoryUtils.getRoomCategoriesFromHotel(
                          inventory.hotel,
                          inventory.roomCategoryName,
                          allocationRooms
                      )
                    : allocationRooms;

            roomTypes = _reject(roomTypes, function(o) {
                return o.name === room.name;
            });
        } else {
            roomTypes = _reject(allocationRooms, function(o) {
                return o.name === room.name;
            });
        }

        roomTypes.push(newAllotment);

        roomTypes = InventoryUtils.getRoomTypesSorted(
            roomTypes,
            inventory.hotel.roomCategories.find((r) => r.name === inventory.roomCategoryName).roomTypes
        );

        const dataToSave = { ...this.props.model, allocationRooms: roomTypes };

        this.props.actions.setModelObject(dataToSave);
    }

    render() {
        return (
            <AllocationComponent
                model={this.props.model}
                {...this.state}
                onCheckboxChange={this.onCheckboxChange}
                onConfigurationOptionChange={this.onConfigurationOptionChange}
                onAllocationStatusChange={this.onAllocationStatusChange}
                onRoomTypeMaxAllotmentChange={this.onRoomTypeMaxAllotmentChange}
            />
        );
    }
}

function mapStateToProps(state) {
    let model = {
        ...state.model,
        readOnly: false,
        editIndex: state.model.editIndex === 'undefined' ? -1 : state.model.editIndex
    };

    return {
        token: state.oidc.user !== null ? state.oidc.user.id_token : '',
        settings: state.settings,
        model
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AllocationComponentContainer);
